import Promise from 'bluebird';
import _ from 'underscore';

import { EditableFilterPermanentStorage } from './editable-filter-permanent-storage';

export class RecentFilterPermanentStorage {
  constructor(options = {}) {
    const {
      featureName,
      entityName,
    } = options;
    this.recentFilterStorages = [
      new EditableFilterPermanentStorage({
        ...options,
        storageKey: `recent-filter-campaignwebui-${featureName}-${entityName}/0`,
        isAccountLevel: true,
      }),
      new EditableFilterPermanentStorage({
        ...options,
        storageKey: `recent-filter-campaignwebui-${featureName}-${entityName}/1`,
        isAccountLevel: true,
      }),
      new EditableFilterPermanentStorage({
        ...options,
        storageKey: `recent-filter-campaignwebui-${featureName}-${entityName}/2`,
        isAccountLevel: true,
      }),
    ];
    this.currentIndex = 0;
  }

  /**
   * @returns {Object} Promise that resolve to Filter object that contains query,
   * name and id
  */
  get() {
    const getAllRecentPromise = [];
    _.each(this.recentFilterStorages, (storage) => {
      getAllRecentPromise.push(storage.get());
    });
    return Promise.all(getAllRecentPromise).then((filters) => {
      const result = _.map(filters, (filter) => {
        if (filter && filter.filter) {
          return filter.filter;
        }
        return filter;
      });
      return result;
    });
  }

  /**
   * Save quick filter key and query to session
   * @param {Object} filter - Filter object that contains query, name and id
   * @return {undefined}
   */
  save(filter) {
    const saveFilterPromise = [];
    return this.get().then((filters) => {
      filters.pop();
      filters.unshift(filter);
      _.each(filters, (newFilter, index) => {
        saveFilterPromise.push(this.recentFilterStorages[index].save(newFilter));
      });
      return Promise.all(saveFilterPromise);
    });
  }

  clean() {
    const cleanFilterPromise = [];
    _.each(this.recentFilterStorages, (storage) => {
      cleanFilterPromise.push(storage.clean());
    });
    return Promise.all(cleanFilterPromise);
  }
}
